import { createFileRoute, redirect } from '@tanstack/react-router'

import PemetaanWilkerPage from '@/components/pages/monitoring/_pemetaan-wilker/containers/PemetaanWilkerPage'

/** Sementara: disable detail per kecamatan — set true untuk mengaktifkan kembali */
const ENABLE_DETAIL_KECAMATAN = false

export const Route = createFileRoute(
  '/report/pemetaan-wilker/$provinsiId/$kotaId/'
)({
  beforeLoad: ({ params }) => {
    if (!ENABLE_DETAIL_KECAMATAN) {
      throw redirect({
        to: '/report/pemetaan-wilker/$provinsiId/',
        params: { provinsiId: params.provinsiId }
      })
    }
  },
  component: KotaPemetaanWilkerRoute
})

function KotaPemetaanWilkerRoute() {
  const { provinsiId, kotaId } = Route.useParams()
  return <PemetaanWilkerPage provinsiId={provinsiId} kotaId={kotaId} />
}
